const icons = document.querySelectorAll('.c-mobile-nav__icon');
const menu = document.querySelector('.c-mobile-nav');

icons.forEach (icon => {
  icon.addEventListener('click', (event) => {
    icon.classList.toggle("open");
    menu.classList.toggle("open");
  });
});


const buttons = document.querySelectorAll('.c-mobile-nav__button');
const dropdown = document.querySelector('.c-mobile-nav__dropdown');

buttons.forEach (button => {
  button.addEventListener('click', (event) => {
    button.classList.toggle("open");
    dropdown.classList.toggle("open");
  });
});

